<template>
  <div class="AD bc-white padding2" v-title data-title="广告">
    <div class="row justify-content-around pr10 pl10 pt5 pb5">
      <van-button @click="back" class="btn-common" plain type="info">返回</van-button>
      <!-- <van-button @click="saveNotice" class="btn-common" type="info">保存</van-button> -->
    </div>

    <div @click="edit()" class="add">
      <van-icon name="plus" size="30" />
    </div>
    <div v-for="(ad, index) in datas" :key="index" class="ad-item mt5 row align-items-center pt4 pb1 pl1">

      <van-image v-if="ad.url"
        width="20vw"
        height="10vw"
        fit=""
        :src="fileDomain+ad.url"
      >
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
      </van-image>
      <div v-else class="fc-success" style="width: 20vw;height: 10vw;line-height: 10vw;">腾讯广告</div>
      <div class="flex-1 text-left pl5 fs2">
        <div class="fc-primary pb1"><span class="fs1 fc-less">位置:</span>{{getPositionName(ad.position) ||'未知'}}</div>
        <div class="fc-primary pt1"><span class="fs1 fc-less">链接:</span>{{ad.link ||'无'}}</div>
      </div>
      <div class="fc-danger pl2 pr2">
        <div class="pb1"><van-button plain round type="danger" size="mini"
        @click.stop="deleteImage(ad)">删除</van-button></div>
        <div class=""><van-button plain round type="info" size="mini"
        @click.stop="edit(ad)">修改</van-button></div>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { SWIPER_TYPES } from '@/uitls/const';
import config from '../../config';
import {
  sendRequest, deleteimages, getads,
} from '../../network/NetworkAccessor';

export default Vue.extend({
  name: 'AD',
  components: {},
  data() {
    return {
      loading: false,
      fileDomain: config.FILE_DOMAIN,
      positions: {
        1: '顶部',
        2: '中间',
      },
      types: {
        1: '龙虾',
        2: '螃蟹',
      },
      datas: [],
    };
  },
  methods: {
    getPositionName(value) {
      return (SWIPER_TYPES.find(item => item.value === value) || {}).text;
    },
    deleteImage(item = {}) {
      this.$dialog.confirm({
        title: '删除',
        message: '确定删除吗？',
      }).then(() => {
        // on confirm
        sendRequest(deleteimages, {
          id: item.id,
        }).then((res) => {
          // console.log(res);
          this.datas = this.datas.filter(d => d.id !== item.id);
          this.$dialog.alert({
            message: '已删除',
          });
        }).catch((e) => {
          console.log(e);
          this.$dialog.alert({
            message: e.message || '啊哦，出错了',
          });
        });
      }).catch(() => {
        // on cancel
      });
    },
    edit(item = {}) {
      this.$router.push(`/AD/info/edit/${item.id || ''}`);
    },
    getAD() {
      sendRequest(getads, {}).then((res) => {
        // console.log(res);
        this.datas = res || [];
      }).catch((e) => {
        console.log(e);
        this.$dialog.alert({
          message: e.message || '啊哦，出错了',
        });
      });
    },
    back() {
      this.$router.back();
    },
  },
  created() {
    this.getAD();
  },
});
</script>
<style scoped>
  .AD {
    min-height: 100vh;
  }
  .add {
    width: 200px;
    height: 100px;
    line-height: 110px;
    border: 1px dashed #2c2c2c;
    margin: 15px auto;
  }
  .ad-item {
    border-radius: 6px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
</style>
